import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import { colors } from '../../styles/theme.js';
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';
import CategoryIcon from '@mui/icons-material/Category';
import ChecklistIcon from '@mui/icons-material/Checklist';
import InventoryIcon from '@mui/icons-material/Inventory';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import GavelIcon from '@mui/icons-material/Gavel';

const tabs = [
  { label: 'Templates', path: '/config/templates', icon: <ViewQuiltIcon /> },
  { label: 'Kategorien', path: '/config/categories', icon: <CategoryIcon /> },
  { label: 'Check Packs', path: '/config/check-packs', icon: <InventoryIcon /> },
  { label: 'Checks', path: '/config/checks', icon: <ChecklistIcon /> },
  { label: 'Quick-Wins', path: '/config/quick-wins', icon: <TipsAndUpdatesIcon /> },
  { label: 'Disclaimer', path: '/config/disclaimer', icon: <GavelIcon /> },
];

export default function ConfigLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const currentTab = tabs.findIndex((t) => location.pathname.startsWith(t.path));

  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 600, mb: 3 }}>
        Konfigurator
      </Typography>

      <Tabs
        value={currentTab === -1 ? 0 : currentTab}
        onChange={(_, idx) => navigate(tabs[idx].path)}
        sx={{
          mb: 4,
          borderBottom: 1,
          borderColor: 'divider',
          '& .MuiTab-root': {
            color: colors.black85,
            fontWeight: 500,
            '&.Mui-selected': {
              bgcolor: colors.black,
              color: colors.lime,
              borderRadius: '8px 8px 0 0',
              fontWeight: 600,
            },
          },
          '& .MuiTabs-indicator': { bgcolor: colors.lime },
        }}
      >
        {tabs.map((tab) => (
          <Tab key={tab.path} icon={tab.icon} iconPosition="start" label={tab.label} />
        ))}
      </Tabs>

      <Outlet />
    </Box>
  );
}
